module.exports = __webpack_public_path__ + "static/investmentsInfo-2cbbbe39d3ba584405155869c9c34b74.svg";